import { render, staticRenderFns } from "./EditarLista.vue?vue&type=template&id=74184b1a&"
import script from "./EditarLista.vue?vue&type=script&lang=js&"
export * from "./EditarLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports